<template>
  <div>
    <DashboardHeader title="Cancel Payment">
      <v-row>
        <v-flex class="mx-auto mt-10" xs12 md8>
          <v-card class="mx-auto mt-10" elevation="12">
            <v-img class="mt-4 mb-14 mx-10" :src="getApiUrl+'/images/bitspay/payfast_trans.png'"></v-img>
            <v-row>
              <v-alert class="mx-auto" type="error" width="90%">
                <v-row>
                  <h1 class="mx-auto">Payment Cancelled!</h1>
                  <br />
                </v-row>
              </v-alert>
            </v-row>
            <v-row>
              <v-btn
                :to="{name:'switchboard'}"
                class="mx-auto my-10"
                width="90%"
                :color="getThemeColor"
                dark
              >Go Back To Switchboard</v-btn>
            </v-row>
          </v-card>
        </v-flex>
      </v-row>
    </DashboardHeader>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import DashboardHeader from "@/components/DashboardHeader";

export default {
  components: { DashboardHeader },
  computed: {
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    }
  }
};
</script>

<style>
</style>